import React, { useContext } from 'react';
import { string } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { RecentPurchases as RecentPurchasesComponent } from '@thd-olt-component-react/recent-order-details';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { getHydrationOptions } from '../utils/constants';

export function RecentPurchases({ id }) {
  const { isConsumerApp, channel } = useContext(ExperienceContext);

  return (
    <ErrorBoundary name="recent-purchases">
      <QueryProvider cachekey="recent-purchases">
        <Hydrator
          placeholder={getHydrationOptions(channel, isConsumerApp).PLACEHOLDER_SECTION}
          delay={isConsumerApp && 5000}
          id="recent-purchases-hydrator"
        >
          <RecentPurchasesComponent componentId={id} />
        </Hydrator>
      </QueryProvider>
    </ErrorBoundary>
  );
}

RecentPurchases.propTypes = {
  id: string,
};

RecentPurchases.defaultProps = {
  id: undefined,
};